import { SET_EXTENSION_INSTALLATION_STATS } from './mutationTypes';

export default {
  [SET_EXTENSION_INSTALLATION_STATS](store, value = false) {
    store.installed = value;
  },
};
